import { SearchSelectOption } from '../components/SearchSelect';

// 筛选下拉 (SearchSelect) 选项: 只显示中文名, 重名才补 code; 中文名为空回退 code.
// (code→中文 的展示口径, 见 feedback: 下拉只显示中文名, 重名才补 code)
export function zhOptions<T>(
    items: T[],
    code: (t: T) => string,
    zh: (t: T) => string | undefined,
): SearchSelectOption[] {
    const count = new Map<string, number>();
    items.forEach((t) => {
        const n = zh(t) || '';
        count.set(n, (count.get(n) || 0) + 1);
    });
    return items.map((t) => {
        const v = code(t);
        const n = zh(t) || '';
        return {
            value: v,
            label: !n ? v : (count.get(n) || 0) > 1 ? `${n} (${v})` : n,
        };
    });
}

// 当前值不在候选时补一条占位项 (编辑老数据 / 无设备查看权时候选为空), 只读回显不丢值.
export function withCurrent(
    opts: SearchSelectOption[],
    cur: string,
    label: string = cur,
): SearchSelectOption[] {
    if (!cur || opts.some((o) => o.value === cur)) return opts;
    return [...opts, { value: cur, label }];
}

// 原生 select 迁 SearchSelect: 调用方传的 className 常带 .sel (触发按钮已自带), 去掉只留宽度/布局类;
// 只剩空串时按 .sel 的 width:100% 给 w-full.
export function selLayoutCls(cls?: string): string | undefined {
    if (cls == null) return undefined;
    return (
        cls
            .replace(/\bsel\b/g, '')
            .replace(/\s+/g, ' ')
            .trim() || 'w-full'
    );
}

/** 启用/停用下拉候选 (值 '1' / '0', 各编辑弹窗共用) */
export const ENABLED_OPTS: SearchSelectOption[] = [
    { value: '1', label: '启用' },
    { value: '0', label: '停用' },
];
